<template>
  <router-link v-if="username" :to="{ name, params: { username }}" class="menu-profile-item">
    <user-icon size="1x" class="header-menuitem-icon" v-if="hasIcon"></user-icon>
    <slot></slot>
  </router-link>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { RouteNames } from '@/router/RouteNames';
import { UserIcon } from 'vue-feather-icons';

@Component({
  components: {
    UserIcon
  }
})
export default class ARouterLinkProfile extends Vue {
  @Prop({ required: true })
  username!: string;

  @Prop(Boolean)
  hasIcon!: boolean;

  name = RouteNames.ROUTE_PROFILE;
}
</script>
